export default __webpack_public_path__ + "static/media/24_2_1.3dcc6264.png";